/**
 * A tiny, framework-free signal: "the company's subscription may have changed on the server" (a trial was started, a
 * plan changed, a cancel was scheduled, a payment was confirmed). `useCurrentSubscription` listens and re-reads the
 * server's answer, so the site-wide banner and the topbar badge update at once instead of waiting for the next
 * navigation. It carries no data — the server's response is always re-fetched, never assumed.
 */
const target = new EventTarget();
const EVENT = 'subscription-changed';

export function notifySubscriptionChanged(): void {
  target.dispatchEvent(new Event(EVENT));
}

export function onSubscriptionChanged(listener: () => void): () => void {
  target.addEventListener(EVENT, listener);
  return () => target.removeEventListener(EVENT, listener);
}
